<template>
    <ul v-if="items" role="menu">
        <template v-for="(item, i) of items">
            <li v-if="visible(item) && !item.separator" :key="item.label || i" :class="[{'layout-root-menuitem': root, 'active-menuitem': activeIndex === i && !item.to && !item.disabled}]" role="menuitem">
                <div v-if="root && isStatic()" class="layout-menuitem-text">{{item.label}}</div>
                <router-link v-if="item.to" :to="item.to" :style="item.style" :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]" active-class="active-route" :target="item.target"
                    exact @click="onMenuItemClick($event, item, i)" @mouseenter="onMenuItemMouseEnter(i)" v-ripple>
                    <i :class="['layout-menuitem-icon', item.icon]"></i>
                    <span class="layout-menuitem-text" v-html="highlightText(item.label)"></span>
                    <i v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
                    <Badge v-if="item.badge" :value="item.badge" severity="success"></Badge>
                </router-link>
                <a v-if="!item.to" :href="item.url||'#'"  :style="item.style" :class="[item.class, 'p-ripple', {'p-disabled': item.disabled}]" :target="item.target"
                    @click="onMenuItemClick($event,item,i)" @mouseenter="onMenuItemMouseEnter(i)" role="menuitem" v-ripple>
                    <i :class="['layout-menuitem-icon', item.icon]"></i>
                    <span class="layout-menuitem-text" v-html="highlightText(item.label)"></span>
                    <i v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
                    <Badge v-if="item.badge" :value="item.badge" severity="success"></Badge>
                </a>
                <transition name="layout-menu">
                    <appsubmenu v-show="item.items && root && isStatic() ? true : (activeIndex === i || hasActiveSearch)" :items="visible(item) && item.items" 
                        :menuActive="menuActive" :menuMode="menuMode" :parentMenuItemActive="activeIndex === i" :searchQuery="searchQuery" @menuitem-click="$emit('menuitem-click', $event)"></appsubmenu>
                </transition>
            </li>
        </template>
    </ul>
</template>

<script>
import EventBus from './event-bus';
export default {
    name: 'appsubmenu',
    emits: ['root-menuitem-click', 'menuitem-click'],
    props: {
        items: Array,
        menuMode: String,
        menuActive: {
            type: Boolean,
            default: false,
        },
        root: {
            type: Boolean,
            default: false,
        },
        parentMenuItemActive: {
            type: Boolean,
            default: false,
        },
        searchQuery: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            activeIndex: null,
        };
    },
    computed: {
        hasActiveSearch() {
            return this.searchQuery && this.searchQuery.trim() !== '';
        }
    },
    mounted() {
		EventBus.on('reset-active-index', () => {
			if (this.isSlim() || this.isHorizontal()) {
				this.activeIndex = null;
			}
		});
	},
    methods: {
        highlightText(text) {
            if (!this.hasActiveSearch || !text) {
                return text;
            }
            
            const query = this.searchQuery.toLowerCase();
            const lowerText = text.toLowerCase();
            const index = lowerText.indexOf(query);
            
            if (index === -1) {
                return text;
            }
            
            const before = text.substring(0, index);
            const match = text.substring(index, index + query.length);
            const after = text.substring(index + query.length);
            
            return `${before}<mark class="menu-search-highlight">${match}</mark>${after}`;
        },
        onMenuItemClick(event, item, index) {
            if (item.disabled) {
                event.preventDefault();
                return;
            }
            //execute command
            if (item.command) {
                item.command({ originalEvent: event, item: item });
                event.preventDefault();
            }
            if (item.items) {
                event.preventDefault();
            }
            if (this.root) {
                this.$emit('root-menuitem-click', {
                    originalEvent: event,
                });
            }
            
            // Auto-close menu on mobile when clicking a link (not a parent)
            if (item.to && this.isMobile() && !item.items) {
                // Emit event to parent to close menu
                this.$emit('menuitem-click', {
                    originalEvent: event,
                    item: item,
                    closeMenu: true
                });
            }
            if (item.items) {
                this.activeIndex = index === this.activeIndex ? null : index;
            }
            else {
                this.activeIndex = index;
                
				if (this.menuMode !== 'sidebar') {
					const ink = this.getInk(event.currentTarget);
					if (ink) {
						this.removeClass(ink, 'p-ink-active');
					}
				}
			}
            this.$emit('menuitem-click', {
                originalEvent: event,
                item: item,
            });
        },
        onMenuItemMouseEnter(index) {
            if (this.root && this.menuActive && (this.isHorizontal() || this.isSlim()) && !this.isMobile()) {
                this.activeIndex = index;
            }
        },
        visible(item) {
            return typeof item.visible === 'function' ? item.visible() : item.visible !== false;
        },
        isMobile() {
            return window.innerWidth <= 991;
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        isSlim() {
            return this.menuMode === 'slim';
        },
        isHorizontal() {
            return this.menuMode === 'horizontal';
        },
        getInk(el) {
			for (let i = 0; i < el.children.length; i++) {
				if (typeof el.children[i].className === 'string' && el.children[i].className.indexOf('p-ink') !== -1) {
					return el.children[i];
				}
			}
			return null;
		},
		removeClass(element, className) {
			if (element.classList)
				element.classList.remove(className);
			else
				element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
    }
};
</script>

<style scoped>
:deep(.menu-search-highlight) {
	background-color: rgba(255, 193, 7, 0.3);
	font-weight: 500;
	padding: 0 2px;
	border-radius: 2px;
}

/* Touch-friendly spacing on mobile */
@media (max-width: 991px) {
	:deep(.layout-menuitem-text) {
		font-size: 0.95rem;
	}
	
	:deep(a) {
		padding: 0.875rem 1rem !important;
		min-height: 48px;
		display: flex;
		align-items: center;
	}
	
	:deep(.layout-menuitem-icon) {
		font-size: 1.1rem;
	}
	
	/* Tap feedback */
	:deep(a:active) {
		background: var(--surface-hover) !important;
		transform: scale(0.98);
	}
}
</style>
